.fileInput {
  display: flex;
}

#file-name-input {
  margin-right: calc(2 * var(--spacer));
}

gz-info-box {
  &::part(container) {
    width: 100%;
  }
}
